<template>
    <b-row>
        <iq-card>
            <template v-slot:body>
                <b-overlay :show="loadingState">
                <b-row>
                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            :label="$t('retailerManagement.fiscal_year')"
                            label-for="fiscal_year_id"
                            >
                            <b-form-select
                            plain
                            v-model="productget.fiscal_year"
                            :options="fiscalYearList"
                            id="fiscal_year_id"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            :label="$t('retailerManagement.month')"
                            label-for="month_id"
                            >
                            <b-form-select
                            plain
                            v-model="search.month_id"
                            :options="monthList"
                            id="month_id"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            :label="$t('retailerManagement.delivery_for')"
                            label-for="type_id"
                            >
                            <b-form-select
                            plain
                            v-model="search.type_id"
                            :options="registrationTypeList"
                            id="type_id"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            :label="$t('globalTrans.name')"
                            label-for="user_id"
                            >
                            <v-select name="user_id"
                              v-model="search.user_id"
                              label="text"
                              :reduce="item => item.value"
                              :options="agentNameList"
                              :placeholder="$t('globalTrans.select')"
                              :filter-by="myFilter"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col xl="3" lg="3" md="6" sm="12" xs="12">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="date_from"
                        >
                            <template v-slot:label>
                                {{$t('retailerManagement.delivery_date_from')}}
                            </template>
                            <b-form-input class="form-control"
                                v-model="search.est_date_from"
                                placeholder="Select Date"
                                id="date_from"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col xl="3" lg="3" md="6" sm="12" xs="12">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="date_to"
                        >
                            <template v-slot:label>
                                {{$t('retailerManagement.delivery_date_to')}}
                            </template>
                            <b-form-input class="form-control"
                                v-model="search.est_date_to"
                                placeholder="Select Date"
                                id="date_to"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" lg="6" xl="4">
                    <b-button style="margin-top: 11%" type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col md="12" class="table-responsive">
                    <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                        <template v-slot:cell(index)="data">
                            {{ $n(data.index + pagination.slOffset) }}
                        </template>
                        <template v-slot:cell(delivery_date)="data">
                            <span class="capitalize">{{ data.item.delivery_date | dateFormat }}</span>
                        </template>
                        <template v-slot:cell(delivery_id)="data">
                            <span class="capitalize" v-if="data.item.product_type === 1">{{ 'P - ' }}{{ data.item.delivery_id }}</span>
                            <span class="capitalize" v-else>{{ 'W - ' }}{{ data.item.delivery_id }}</span>
                        </template>
                        <template v-slot:cell(demmand_id)="data">
                            <span class="capitalize">{{ data.item.demand.demmand_id }}</span>
                        </template>
                        <template v-slot:cell(name)="data">
                            <span class="capitalize">{{ data.item.name }}</span>
                        </template>
                        <template v-slot:cell(rec_status)="data">
                            <span v-if="data.item.rec_status == 1" class="capitalize badge badge-danger">{{ $t('globalTrans.pending') }}</span>
                            <span v-else class="capitalize badge badge-warning">{{ $t('sales_distribution_admin.partial') }}</span>
                        </template>
                        <template v-slot:cell(action)="data">
                          <span class="d-flex">
                            <a href="javascript:" class="btn_table_action btn_green" :title="$t('globalTrans.details')" v-b-modal.modal-details @click="details(data.item)"><i class="fas fa-eye"></i></a>
                            <a href="javascript:" class="btn_table_action btn_blue" :title="$t('externalUser.production.receive_now')" v-b-modal.modal-receive size="sm" @click="receive(data.item)"><i class="ri-check-line m-0"></i></a>
                          </span>
                        </template>
                    </b-table>
                    <b-pagination
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total-rows="pagination.totalRows"
                        @input="searchData"
                        />
                    </b-col>
                </b-row>
                </b-overlay>
            </template>
        </iq-card>
        <b-modal id="modal-details" size="lg"  :title="formTitle" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
            <Details :id="editItemId" />
        </b-modal>
        <b-modal id="modal-receive" size="lg" :title="receiveTitle" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
            <ReceiveModal :id="editItemId" :key="editItemId" />
        </b-modal>
    </b-row>
</template>
<script>

import ReceiveModal from '../ReceiveModal'
import Details from './Details'
import flatpickr from 'flatpickr'
import { mapGetters } from 'vuex'
import RestApi, { productionServiceBaseUrl, commonServiceBaseUrl } from '@/config/api_config'
import { deliveryOrderToReceiveListApi, fiscalYearData } from '../../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
   components: {
     Details, ReceiveModal
  },
  data () {
    return {
      saveBtnName: this.$t('globalTrans.save'),
      search: {
        delivery_type: 3,
        fiscal_year_id: 0,
        fis_start_date: 0,
        fis_end_date: 0,
        est_date_from: '',
        est_date_to: '',
        month_id: 0,
        type_id: 0,
        user_id: ''
      },
      productget: {
        fiscal_year: 0
      },
      delivery_type: 0,
      user_id: 0,
      rows: [],
      agentNameList: [],
      editItemId: 0,
      productQuantityList: {}
    }
  },
  computed: {
    formTitle () {
       return this.$t('sales_distribution_admin.delivery_order') + ' ' + this.$t('sales_distribution_admin.details')
    },
    currentLocale () {
      return this.$i18n.locale
    },
    receiveTitle () {
      return this.$t('sales_distribution_admin.delivery_order') + ' ' + this.$t('sales_center.receive')
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0).sort((a, b) => b.value - a.value).slice(0, 3)
    },
    monthList () {
      const objectData = this.$store.state.commonObj.monthList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    registrationTypeList: function () {
        const list = [
          { value: 1, text: 'Dealer' },
          { value: 2, text: 'Retailer' }
        ]
        const listbn = [
          { value: 1, text: 'ব্যবসায়ী' },
          { value: 2, text: 'খুচরা বিক্রেতা' }
        ]
        return this.$i18n.locale === 'bn' ? listbn : list
    },
    columns () {
        const labels = [
              { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
              { label: this.$t('retailerManagement.delivery_date'), class: 'text-center' },
              { label: this.$t('retailerManagement.delivery_id'), class: 'text-center' },
              { label: this.$t('retailerManagement.demand_id'), class: 'text-center' },
              { label: this.$t('retailerManagement.recipient_name'), class: 'text-center' },
              { label: this.$t('globalTrans.status'), class: 'text-center' },
              { label: this.$t('globalTrans.action'), class: 'text-center' }
            ]

        let keys = []
          if (this.$i18n.locale === 'bn') {
          keys = [
              { key: 'index' },
              { key: 'delivery_date' },
              { key: 'delivery_id' },
              { key: 'demand.demmand_id' },
              { key: 'name_bn' },
              { key: 'rec_status' },
              { key: 'action' }
            ]
          } else {
            keys = [
            { key: 'index' },
              { key: 'delivery_date' },
              { key: 'delivery_id' },
              { key: 'demand.demmand_id' },
              { key: 'name' },
              { key: 'rec_status' },
              { key: 'action' }
            ]
          }
        return labels.map((item, index) => {
            return Object.assign(item, keys[index])
        })
    },
    categoryList: function () {
        return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  watch: {
    'productget.fiscal_year': function (newVal) {
      RestApi.getData(commonServiceBaseUrl, `${fiscalYearData}/${newVal}`).then(response => {
        this.search.fiscal_year_id = response.data.id
        this.search.fis_start_date = response.data.start_date
        this.search.fis_end_date = response.data.end_date
      })
    },
    'search.type_id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.agentNameList = this.getDealerRetailerListByType(newVal)
        }
      }
  },
  created () {
      this.loadData()
  },
  mounted () {
    flatpickr('#date_from', {})
    flatpickr('#date_to', {})
  },
  methods: {
    myFilter: (option, text, search) => {
        const temp = search.toLowerCase()
        return option.text_en.toLowerCase().indexOf(temp) > -1 ||
        option.text_bn.toLowerCase().indexOf(temp) > -1
    },
    details (item) {
      this.editItemId = item.id
    },
    receive (item) {
      this.editItemId = item.id
    },
    searchData () {
        this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, deliveryOrderToReceiveListApi, params).then(response => {
          if (response.success) {
            this.$store.dispatch('setList', this.getRelationalData(response.data.data))
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
        const listData = data.map(item => {
            const tmpName = this.productCommonObj.dealerRetailerList.find(user => user.value === parseInt(item.del_or_retail_sc_id))
            const nameData = {
                name: tmpName !== undefined ? tmpName.text_en : '',
                name_bn: tmpName !== undefined ? tmpName.text_bn : ''
            }
            return Object.assign({}, item, nameData)
        })
        return listData
    },
    getDealerRetailerListByType (typeId) {
        return this.productCommonObj.dealerRetailerList.filter(item => item.type === typeId)
    }
  }
}
</script>
